/**
 * Node border states, one rule for every node type.
 *
 * selectedBorder — a SELECTED node's border is the palette's foreground: near
 * white on a dark palette, near black on a light one. Punchy on purpose, and the
 * same on every node whatever its own colour (Florent, 2026-10-02: "a white
 * punchy border in dark mode, a dark punchy border in light modes"). The node's
 * own colour is accepted and ignored so call sites read as "the selected
 * version of this border".
 *
 * activeBorder — a node that is RUNNING / ACTIVE (a state machine evaluating,
 * an eye follow driving the eyes) shows its own border colour brighter, not a
 * neon of its hue: each RGB channel times `factor`, clamped, alpha kept. A
 * non-hex colour goes through CSS relative colour syntax.
 *
 * Lives under components/nodes/ because node colour is functional colour,
 * which the palette lock treats as such.
 */
export const SELECTED_BORDER = 'var(--m-fg)'
export const ACTIVE_BRIGHTNESS = 1.6

// eslint-disable-next-line no-unused-vars
export function selectedBorder(_ownColor) {
  return SELECTED_BORDER
}

export function activeBorder(color, factor = ACTIVE_BRIGHTNESS) {
  if (typeof color !== 'string' || color === '') return color
  const hex = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.exec(color.trim())
  if (!hex) {
    return `rgb(from ${color} calc(r * ${factor}) calc(g * ${factor}) calc(b * ${factor}) / alpha)`
  }
  let h = hex[1]
  if (h.length <= 4) h = [...h].map(c => c + c).join('')
  const ch = (i) => parseInt(h.slice(i, i + 2), 16)
  const up = (v) => Math.min(255, Math.round(v * factor)).toString(16).padStart(2, '0')
  const alpha = h.length === 8 ? h.slice(6, 8) : ''
  return `#${up(ch(0))}${up(ch(2))}${up(ch(4))}${alpha}`
}
